const { defaultsDeep } = require("lodash");

$(document).ready(function() {
	// Initialize Textillate movements
	$(function () {
        // $('.normal-text').textillate({
        //     initialDelay: 600,
        // });
        $('.slide-subtitle .special-text').textillate({
            initialDelay: 250,
            in: { effect: 'rollIn' }
        });
        if(window.matchMedia("(max-width: 767px)").matches){
            // The viewport is less than 768 pixels wide
        } else{
            // The viewport is at least 768 pixels wide
        }
    })
});